"use strict";

document.addEventListener("DOMContentLoaded", function () {
  var adpPopup = {};

  (function () {
    var $this;

    adpPopup = {
      sPrevious: window.scrollY,
      sDirection: "down",

      /*
       * Initialize
       */
      init: function (e) {
        $this = adpPopup;

        // The date-of-birth controller binds BEFORE popupInit. popupInit is
        // what opens the gate and, for a visitor whose cookie already reads
        // "no", immediately calls ageDeclined() - which strips the page. The
        // recovery button lives in the panel that call reveals, so its listener
        // has to already be attached by then.
        $this.ageDob.init(e);

        $this.popupInit(e);

        // Init events.
        $this.events(e);
      },

      /*
       * Events
       */
      events: function (e) {
        // Custom Events
        document.addEventListener("click", function (event) {
          if (
            event.target.matches(".popup-close") ||
            event.target.closest(".popup-close")
          ) {
            $this.closePopup(event);
          }
          if (
            event.target.matches(".popup-accept") ||
            event.target.closest(".popup-accept")
          ) {
            $this.acceptPopup(event);
            $this.closePopup(event);
          }
          // REMOVED: the two delegated handlers for the superseded yes/no gate,
          // .age-verification__popup-close ("I am 18 or over") and
          // .age-verification__button-no ("Exit site").
          //
          // The markup was already gone from sections/age-verification.liquid,
          // but these listeners were still live and still bound to agePopup() -
          // a working ONE-TAP AFFIRM path that would grant entry to anything
          // carrying that class, with no date of birth entered. That is the
          // exact bypass the date-of-birth gate exists to remove, and it would
          // have re-armed itself the moment the class reappeared anywhere.
          //
          // The only affirm path is now ageDob's submit() -> admit(), which
          // reaches agePopup() only after a real date has been entered and
          // measured. Do not re-add a class-triggered affirm.

          // Declined-panel recovery. Clears the session "no" cookie then reloads
          // so the DOB entry panel returns. Never admits on its own.
          if (
            event.target.matches("[data-tpsg-recover]") ||
            event.target.closest("[data-tpsg-recover]")
          ) {
            event.preventDefault();
            $this.ageRecover();
          }
        });

        // Checking this will cause popup to close when user presses key.
        document.addEventListener("keyup", function (event) {
          // Press ESC to Close.
          // :not([data-tpsg-modal="true"]) fences the 18+ gate out BY CONSTRUCTION.
          //
          // ⚠️ THIS HOOK CHANGED 2026-09-15 AND THE REASON MATTERS.
          // It used to key off aria-modal="true". aria-modal was REMOVED from the
          // gate markup because it makes assistive technology ignore everything
          // outside the dialog — including the mandated Schedule 1 warning band,
          // which must stay reachable (reg 17(3)). But aria-modal was also doing
          // THREE jobs in this file: this ESC fence, the F4 fence below, and
          // modalGuard.engage()'s precondition. Dropping the attribute without
          // re-pointing all three would have made ESC and F4 CLOSE THE AGE GATE —
          // a fail-open on a legal control.
          // data-tpsg-modal carries the behaviour; it has no accessibility
          // semantics, so the band stays exposed. Do not re-point these at a
          // role or an ARIA attribute.
          // The gate carries no data-esc-close today, so it was already skipped
          // incidentally - but ESC dismissing a legal age-verification control
          // would defeat the control, and "it happens to have no attribute"
          // is not a control. The only exits are the two affirmation buttons.
          if (event.key === "Escape") {
            document
              .querySelectorAll(
                '.popup-open[data-esc-close="true"]:not([data-tpsg-modal="true"])'
              )
              .forEach(function (popup) {
                $this.closePopup(popup);
              });
          }

          // Press F4 to Close. Same fence, same reason.
          if (event.key === "F4") {
            document
              .querySelectorAll(
                '.popup-open[data-f4-close="true"]:not([data-tpsg-modal="true"])'
              )
              .forEach(function (popup) {
                $this.closePopup(popup);
              });
          }
        });

        // Checking this will cause popup to close when user clicks on overlay.
        document.querySelectorAll(".popup-overlay").forEach((element) => {
          element.addEventListener("click", (event) => {
            if (
              element.previousElementSibling.matches(
                '.popup-open[data-overlay-close="true"]'
              )
            ) {
              $this.closePopup(element.previousElementSibling);
            }
          });
        });
      },

      /*
       * Init popup elements
       */
      popupInit: function (e) {
        // Set scroll direction.
        document.addEventListener("scroll", function () {
          let scrollCurrent = window.scrollY;
          if (scrollCurrent > $this.sPrevious) {
            $this.sDirection = "down";
          } else {
            $this.sDirection = "up";
          }
          $this.sPrevious = scrollCurrent;
        });

        // Open popup
        document.querySelectorAll(".popup").forEach(function (popup) {
          // Manual Launch.
          if ("manual" === popup.getAttribute("data-open-trigger")) {
            let selector = popup.getAttribute("data-open-manual-selector");
            if (selector) {
              const onTriggerClick = (event) => {
                event.preventDefault();
                if (
                  event.target.closest(".popup-close") ||
                  event.target.closest(".popup-overlay") ||
                  event.target.closest(".popup-button")
                ) {
                  popup.classList.remove("popup-already-opened");
                  $this.openPopup(popup);
                  if (event.target.classList.contains("popup")) {
                    $this.closePopup(selector);
                  }
                }
              };

              const triggerInteraction = (triggerElement) => {
                if (!triggerElement) return;
                triggerElement.addEventListener("click", onTriggerClick);

                const isClickableOverlay =
                  triggerElement.getAttribute("data-overlay-close") === "true";
                const overlay = triggerElement.nextElementSibling;
                if (
                  isClickableOverlay &&
                  overlay &&
                  overlay.classList.contains("popup-overlay")
                ) {
                  overlay.addEventListener("click", onTriggerClick);
                }
              };

              let triggerEl;

              if (selector.charAt(0) == "#") {
                triggerEl = document.getElementById(selector.slice(1));
              } else {
                triggerEl = document.querySelector(selector);
              }

              triggerInteraction(triggerEl);
            }
          }
          // Checks whether a popup should be displayed or not.
          // THE GATE IS TESTED FIRST, deliberately. && evaluates left to right,
          // so the old order called isAllowPopup() for the 18+ gate as well -
          // even though the gate is exempt from its verdict either way. That
          // call did two unwanted things on the legal control's critical path:
          // it READ localStorage (the binding privacy rule for this surface is
          // zero web storage in the gate path), and it dereferenced
          // Shopify.designMode unguarded, so a storefront rendered without the
          // Shopify global threw INSIDE this forEach and aborted popupInit
          // entirely - the gate never mounted. Fail-OPEN, the same class of
          // defect the getStorage try/catch note at the bottom of this file
          // records. Short-circuiting on the class removes both.
          if (
            !popup.classList.contains("age-verification") &&
            !$this.isAllowPopup(popup)
          ) {
            return;
          }
          $this.openTriggerPopup(popup);
        });
      },

      /*
       * Trigger open popup
       */
      openTriggerPopup: function (popup) {
        const trigger = popup.getAttribute("data-open-trigger");
        // Age Verification.
        if (trigger === "none") {
          const designMode = !!(window.Shopify && Shopify.designMode);
          const state = $this.ageState();

          if (state === "ok" && !designMode) {
            // Affirmed earlier in THIS browser session. Keep the pre-paint
            // suppression class the head probe set, and make sure no later code
            // path can re-open the gate for this page view.
            document.documentElement.classList.add("tps-age-ok");
            popup.classList.add("popup-already-opened");
          } else {
            // Unknown, declined, or the theme editor -> the gate paints.
            // Clearing the class is load-bearing: the gate is display:none
            // while it is set (see the fail-closed rules in base.css).
            document.documentElement.classList.remove("tps-age-ok");
            $this.openPopup(popup);

            // A declined visitor STAYS declined for the rest of the session.
            // Reload, a new tab and a deep-linked flavour PDP all land straight
            // back on the blocked panel instead of on the catalogue.
            if (state === "no" && !designMode) {
              $this.ageDeclined();
            }
          }
        }
        // Time Delay.
        if (trigger === "delay") {
          setTimeout(function () {
            $this.openPopup(popup);
          }, parseInt(popup.getAttribute("data-open-delay-number")) * 1000);
        }
        // Exit Intent.
        if (trigger === "exit") {
          var showExit = true;
          document.addEventListener("mousemove", function (event) {
            var scroll =
              window.pageYOffset || document.documentElement.scrollTop;
            if (event.pageY - scroll < 7 && showExit) {
              $this.openPopup(popup);
              showExit = false;
            }
          });
        }
        // Scroll Position.
        if (trigger === "scroll") {
          const pointScrollType = popup.getAttribute("data-open-scroll-type");
          const pointScrollPosition = Number(
            popup.getAttribute("data-open-scroll-position")
          );
          document.addEventListener("scroll", function () {
            if (pointScrollType === "px") {
              if (window.scrollY >= pointScrollPosition) {
                $this.openPopup(popup);
              }
            }
            if (pointScrollType === "%") {
              if ($this.getScrollPercent() >= pointScrollPosition) {
                $this.openPopup(popup);
              }
            }
          });
        }
        // Accept Agreement.
        if (trigger === "accept") {
          let accept = $this.getStorage(
            "popup-accept-" + (popup.getAttribute("data-id") || 0)
          );
          if (!accept || (window.Shopify && Shopify.designMode)) {
            $this.openPopup(popup);
          }
        }
      },

      /*
       * Trigger close popup
       */
      closeTriggerPopup: function (popup) {
        var trigger = popup.getAttribute("data-close-trigger");
        // Time Delay.
        if (trigger === "delay") {
          setTimeout(function () {
            $this.closePopup(popup);
          }, parseInt(popup.getAttribute("data-close-delay-number")) * 1000);
        }
        // Scroll Position.
        if (trigger === "scroll") {
          const pointScrollType = popup.getAttribute("data-close-scroll-type");
          const pointScrollPosition = Number(
            popup.getAttribute("data-close-scroll-position")
          );

          document.addEventListener("scroll", function () {
            if (pointScrollType === "px") {
              if (window.scrollY >= pointScrollPosition) {
                $this.closePopup(popup);
              }
            }

            if (pointScrollType === "%") {
              if ($this.getScrollPercent() >= pointScrollPosition) {
                $this.closePopup(popup);
              }
            }
          });
        }
      },

      /*
       * Open popup
       */
      openPopup: function (popup) {
        // Check already opened.
        if (popup.classList.contains("popup-already-opened")) {
          return;
        }
        if (popup.classList.contains("popup-open")) {
          return;
        }
        // Hide body scroll.
        if (popup.getAttribute("data-body-scroll-disable") === "true") {
          document.body.classList.add("popup-scroll-hidden");

          if (popup.getAttribute("data-mobile-disable") === "false") {
            document.body.classList.add("popup-scroll-hidden-mobile");
          }
        }

        // DISPLAY COUNTER - marketing popups only. The 18+ gate is fenced OUT
        // on the same class that exempts it in popupInit(), so the exemption is
        // stated once and behaves the same in both places. Nothing ever reads
        // this counter for the gate (it is routed past isAllowPopup), so the
        // write bought no behaviour at all - it only put a localStorage read
        // AND write on the legal control's path, against the binding rule that
        // the gate path touches no web storage. Persistence for the gate is the
        // tps_age18 session cookie and nothing else.
        if (!popup.classList.contains("age-verification")) {
          const key = "popup-" + popup.getAttribute("data-id");
          const limit = parseInt($this.getStorage(key) || 0) + 1;
          $this.setStorage(key, limit, {
            expires: popup.getAttribute("data-limit-lifetime"),
          });
        }

        // Display popup.
        popup.classList.add("popup-open");
        // Set current scroll.
        popup.setAttribute("data-init-scroll-px", window.scrollY);
        popup.setAttribute(
          "data-init-scroll-percent",
          $this.getScrollPercent()
        );
        // Open animation.
        let animation = popup.getAttribute("data-open-animation");
        $this.applyAnimation(popup, animation);
        // Init close trigger.
        $this.closeTriggerPopup(popup);

        popup.focus();

        // Modal popups (data-tpsg-modal="true") contain focus + inert the background.
        $this.modalGuard.engage(popup);
      },

      /*
       * Modal guard - focus trap + background inert  (ARG-SITE-02, ported from
       * ported onto this theme's popup.js base; it was a publish blocker once
       * already, so treat it as load-bearing)
       * ----------------------------------------------------------
       * Engages ONLY for popups that declare data-tpsg-modal="true" (today: the 18+
       * age gate). Every other popup keeps its existing behaviour byte for byte.
       * Escape is intentionally not handled here: the gate carries no
       * data-esc-close, so the shared Esc handler skips it and the gate stays up.
       */
      modalGuard: {
        popup: null,
        lastFocused: null,
        inerted: [],
        bound: false,
        observer: null,

        focusables: function (root) {
          var sel =
            'a[href], area[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), iframe, [tabindex]:not([tabindex="-1"]), [contenteditable="true"]';
          return Array.prototype.filter.call(
            root.querySelectorAll(sel),
            function (el) {
              if (el.closest("[hidden]")) return false;
              return !!(
                el.offsetWidth ||
                el.offsetHeight ||
                el.getClientRects().length
              );
            }
          );
        },

        engage: function (popup) {
          // data-tpsg-modal, NOT aria-modal — see the note on the ESC fence above.
          // aria-modal would hide the mandated warning band from assistive tech.
          if (!popup || popup.getAttribute("data-tpsg-modal") !== "true") return;
          if (window.Shopify && Shopify.designMode) return;
          if (this.popup === popup) return;

          this.popup = popup;
          // MEASURED: openPopup() calls popup.focus() BEFORE it calls
          // engage(), so document.activeElement is ALREADY the dialog by the time
          // we get here. Without the two guards below the dialog recorded ITSELF
          // as the restore target, and release() then "restored" focus to an
          // element it had just hidden - leaving a keyboard or screen-reader user
          // with focus on a display:none node and the next Tab starting from the
          // top of the document. Falling through to null sends release() to
          // #MainContent instead, which is the correct destination.
          this.lastFocused =
            document.activeElement &&
            document.activeElement !== document.body &&
            document.activeElement !== popup &&
            !popup.contains(document.activeElement)
              ? document.activeElement
              : null;

          this.inertBackground(popup);
          this.watchBackground(popup);
          this.bind();
          this.focusInto();
        },

        // inertBackground() is a one-shot pass over the DOM as it stands. Nodes
        // appended to <body> AFTER it runs escape the lockout entirely - the
        // SHOP-CART-SYNC node and #omnisend-dynamic-container are both injected
        // late and both landed outside it. They are empty today, so nothing
        // leaks, but a third party that injects a focusable while the gate is up
        // would put it in the tab order behind a legal control.
        //
        // Re-running the same pass on a childList change closes that. It is
        // cheap: the pass skips anything already carrying inert, so a steady
        // state costs one attribute read per top-level node.
        watchBackground: function (popup) {
          var self = this;
          if (this.observer || typeof MutationObserver !== "function") return;
          try {
            this.observer = new MutationObserver(function () {
              if (!self.popup) return;
              self.inertBackground(self.popup);
            });
            this.observer.observe(document.body, { childList: true });
          } catch (error) {
            /* No observer available: the one-shot pass still stands. */
            this.observer = null;
          }
        },

        unwatchBackground: function () {
          if (!this.observer) return;
          try {
            this.observer.disconnect();
          } catch (error) {
            /* already gone */
          }
          this.observer = null;
        },

        // Focus the DIALOG ITSELF (tabindex="-1"), not its first control: the
        // decline button is first in DOM order and a legal 18+ control must not
        // open focused on "decline".
        focusInto: function () {
          if (this.popup) this.popup.focus();
        },

        inertBackground: function (popup) {
          var self = this;
          var node = popup;
          while (node && node !== document.body && node.parentElement) {
            var parent = node.parentElement;
            var current = node;
            Array.prototype.forEach.call(parent.children, function (sib) {
              if (sib === current) return;
              if (sib.hasAttribute("inert")) return;
              // ⚖️ reg 17(3) EXEMPTION — THE MANDATED WARNING IS NEVER INERTED.
              //
              // The Schedule 1 warning band must be "clearly visible at all
              // times". Measured 2026-09-14: this loop set inert + aria-hidden
              // on main#MainContent, and because the band was rendered INSIDE
              // main, its accessibility node resolved `ignored`, reason
              // `ariaHiddenSubtree` — the mandated warning was present on screen
              // but absent from the accessibility tree the whole time the gate
              // was up.
              //
              // Skipping the container here is only HALF the cure, and it does
              // nothing on its own: `inert` and `aria-hidden` are INHERITED and
              // CANNOT be undone on a descendant, so while the band lived inside
              // main no amount of skipping could rescue it. The other half is
              // structural and lives in layout/theme.liquid, which now renders
              // the band as a TOP-LEVEL SIBLING of <main>, ahead of the gate in
              // DOM order. Both halves or the band stays ignored.
              //
              // Safe against becoming a keyboard route around the gate: reg
              // 17(5) forbids any link inside the warning and 17(4)(c) bars a
              // collapse control, so this subtree has ZERO focusable
              // descendants by law. It is exempt from inert, not from the trap.
              // Do not extend this exemption to anything else.
              if (sib.hasAttribute("data-tps-warnband")) return;
              self.inerted.push({
                el: sib,
                hadAria: sib.getAttribute("aria-hidden"),
              });
              sib.setAttribute("inert", "");
              sib.setAttribute("aria-hidden", "true");
            });
            node = parent;
          }
        },

        releaseBackground: function () {
          this.inerted.forEach(function (rec) {
            rec.el.removeAttribute("inert");
            if (rec.hadAria === null) rec.el.removeAttribute("aria-hidden");
            else rec.el.setAttribute("aria-hidden", rec.hadAria);
          });
          this.inerted = [];
        },

        bind: function () {
          if (this.bound) return;
          var self = this;

          this.onKeydown = function (event) {
            if (!self.popup || event.key !== "Tab") return;
            var f = self.focusables(self.popup);
            if (!f.length) {
              event.preventDefault();
              self.popup.focus();
              return;
            }
            var first = f[0];
            var last = f[f.length - 1];
            var active = document.activeElement;

            // TIR-B1. FOCUS ON THE DIALOG CONTAINER ITSELF IS A REAL STATE, AND
            // IT IS THE COLD-LOAD STATE. focusInto() focuses the dialog
            // (tabindex="-1"), NOT a control, so the gate never opens focused on
            // "decline". Neither branch below caught that:
            //   - `!popup.contains(active)` is FALSE, because Node.contains()
            //     returns true for the node itself;
            //   - `active === first` is FALSE, because active is the container,
            //     not the first cell.
            // So the handler fell through, preventDefault() was never called,
            // and the browser performed its own backward move. Every sibling
            // before the dialog is inert, which is how the FIRST Shift+Tab of a
            // session walked out of a legally load-bearing gate onto <body> -
            // and the visitor's next Tab then restarts from the top of the
            // document, outside the control.
            //
            // Handled explicitly in BOTH directions rather than only backwards:
            // forward from the container already landed on `first` natively, so
            // stating it changes no destination, and it removes the last case in
            // this handler that depended on native behaviour. ADDS NO TAB STOP -
            // it only redirects a Tab that was already being pressed.
            if (active === self.popup) {
              event.preventDefault();
              (event.shiftKey ? last : first).focus();
              return;
            }

            if (!self.popup.contains(active)) {
              event.preventDefault();
              first.focus();
              return;
            }
            if (event.shiftKey && active === first) {
              event.preventDefault();
              last.focus();
            } else if (!event.shiftKey && active === last) {
              event.preventDefault();
              first.focus();
            }
          };

          this.onFocusin = function (event) {
            if (!self.popup) return;
            if (self.popup.contains(event.target)) return;
            self.focusInto();
          };

          document.addEventListener("keydown", this.onKeydown, true);
          document.addEventListener("focusin", this.onFocusin, true);
          this.bound = true;
        },

        release: function (popup) {
          if (!this.popup || (popup && popup !== this.popup)) return;
          this.unwatchBackground();
          this.releaseBackground();
          if (this.bound) {
            document.removeEventListener("keydown", this.onKeydown, true);
            document.removeEventListener("focusin", this.onFocusin, true);
            this.bound = false;
          }
          var restore = this.lastFocused;
          this.popup = null;
          this.lastFocused = null;
          if (restore && document.contains(restore)) {
            restore.focus();
            return;
          }
          var main = document.getElementById("MainContent");
          if (main) {
            if (!main.hasAttribute("tabindex")) main.setAttribute("tabindex", "-1");
            // ★ preventScroll IS LOAD-BEARING, NOT A TIDY-UP.
            // HTMLElement.focus() scrolls the focused element into view by
            // default. #MainContent begins exactly one header-height down the
            // document, so the default behaviour scrolled the header clean off
            // the screen the instant a visitor affirmed 18+ - their FIRST view
            // of the store had no logo, no menu, no search and no cart.
            // MEASURED on live 190603821129, cold land then affirm:
            //   390 -> scrollY 155 | 768 -> 155 | 1024 -> 118 | 1440 -> 166
            // and at EVERY width scrollY === #MainContent offsetTop ===
            // header height, with document.activeElement === this <main>.
            // Control: the same page with the cookie preset (no gate) sat at
            // scrollY 0, which is what proves the gate caused it.
            // The focus DESTINATION is deliberately unchanged - #MainContent is
            // still the restore target the block above intends, so keyboard and
            // screen-reader behaviour is identical. Only the browser's scroll
            // side effect is suppressed. Do not "simplify" this to focus():
            // that reintroduces the defect silently and no visual test of the
            // gate itself will catch it.
            // preventScroll degrades safely: a browser that does not support
            // the option ignores it and behaves exactly as this line did before.
            main.focus({ preventScroll: true });
          }
        },
      },

      /*
       * Entry gate persistence
       * ----------------------------------------------------------
       * A SESSION COOKIE, deliberately. Not localStorage, not sessionStorage:
       *   - localStorage remembered "yes" for 360 days and "no" for ZERO
       *     seconds, and Safari ITP evicts it after ~7 idle days anyway.
       *   - sessionStorage is PER TAB. A new tab would re-ask an answered
       *     visitor and - far worse - hand a DECLINED visitor a clean slate.
       * A cookie is shared by every tab of the browser, which is what makes the
       * cadence once-per-VISIT rather than once-per-tab.
       *
       * ★ THE AFFIRMATION IS A SLIDING 1-HOUR WINDOW, NOT A SESSION COOKIE.
       * "ok" is written with Max-Age=AGE_TTL and REFRESHED ON EVERY PAGE LOAD by
       * the pre-paint probe in layout/theme.liquid. Active browsing therefore
       * keeps it alive indefinitely - nobody is re-gated mid-visit - and a
       * returning visitor stays affirmed for 1 hour from their last page view.
       *
       * THE WINDOW WAS 10 MINUTES from 2026-08-06 until 2026-09-08. At that
       * length a shopper working down the 157-row tobacco board could be
       * re-gated MID-SESSION, putting the gate on the purchase path. Raised to
       * 24 hours on 2026-09-08, then cut to 1 hour on 2026-09-13: checkout
       * already runs a proper ID verification process, so a long storefront
       * TTL is not needed as a second force. Neither reg 19 of the Public
       * Health (Tobacco and Other Products) Regulations 2024 nor the
       * Department's Guide to online point-of-sale advertising requirements
       * (Nov 2024, p.12) prescribes ANY duration for the verification: the
       * requirement is a system that limits access to people 18 or over, and
       * every new visitor and every new device is still gated. ONLY the TTL
       * changed - mechanism, copy, declined path and warning furniture are
       * byte-for-byte untouched.
       *
       * It was a session cookie until 2026-08-06, and that WAS the founder's
       * reported "no gate after a restart" bug: Chrome's "Continue where you
       * left off" restores session cookies across a full browser restart, so the
       * affirmation outlived the quit. An expired Max-Age cookie is dropped by
       * the browser even when session restore runs.
       *
       * ⛔ A "last TPS tab closes" heartbeat was considered and REJECTED, and
       * must not be built: pagehide is not guaranteed (crash, force-quit, mobile
       * backgrounding, BFCache) and two tabs closing together race, so it CAN
       * FAIL OPEN. On the control the s 32 permission rests on, only a mechanism
       * that errs toward SHOWING the gate is acceptable.
       *
       * THE REFUSAL IS NOT ON THE TIMER. "no" is still written with NO Max-Age -
       * a session cookie, exactly as before - so a decline is neither shortened
       * nor extended by this change. Only "ok" slides.
       *
       * Values: "ok" = affirmed 18+, "no" = declined. Anything else - an
       * unreadable jar, a tampered value, a throw - reads as unknown, and
       * unknown always means SHOW THE GATE. Consent is never inferred from a
       * failed read.
       */
      AGE_COOKIE: "tps_age18",

      // Seconds. The sliding window for "ok" ONLY - see the note above.
      //
      // 3600 = 1 hour. Was 600 (10 minutes) until 2026-09-08, then 86400
      // (24 hours) until 2026-09-13 — and 86400 SURVIVED HERE even after
      // layout/theme.liquid was moved to 3600. That two-definition drift is the
      // defect this getter exists to make unrepeatable. Measured on live
      // (theme /t/127/) 2026-09-14: setAgeState() wrote Max-Age=86400 on the
      // affirm and only the NEXT page load slid it down to 3600 — so a visitor
      // who affirmed and closed the tab kept a TWENTY-FOUR HOUR pass and never
      // met the hourly re-ask at all. Founder ruling 2026-09-15: 3600
      // EVERYWHERE, the affirm write included. Supersedes the 2026-09-08 note.
      //
      // ⛔ THIS IS NO LONGER A CONSTANT. DO NOT TURN IT BACK INTO ONE.
      // The TTL is authored ONCE, in Liquid, in layout/theme.liquid, and
      // published on <html data-tps-age-ttl>. BOTH readers derive from that one
      // value: the pre-paint probe (which cannot wait for this file to load)
      // and this getter. Re-introducing a literal here re-creates exactly the
      // drift described above, and it will not look like a bug - it will look
      // like tidying up.
      //
      // The fallback is 3600, deliberately NOT 86400: if the attribute is ever
      // stripped, or served stale, the gate must fail toward the SHORTER
      // window. It may never silently restore a 24-hour pass.
      //
      // (Note for future greps: "AGE_TTL" also substring-matches
      // STORAGE_TTL_MS in the top-strip custom_liquid in
      // sections/header-group.json — that is the banner cache, NOT this gate.
      // Use a word-boundary match.)
      get AGE_TTL() {
        var declared = parseInt(
          document.documentElement.getAttribute("data-tps-age-ttl"),
          10
        );
        return declared > 0 ? declared : 3600;
      },

      ageState: function () {
        try {
          const match = String(document.cookie || "").match(
            /(?:^|;\s*)tps_age18=([^;]*)/
          );
          if (!match) return "";
          const value = decodeURIComponent(match[1]);
          return value === "ok" || value === "no" ? value : "";
        } catch (error) {
          return "";
        }
      },

      setAgeState: function (value) {
        try {
          // VALUE-DEPENDENT EXPIRY, and the asymmetry is deliberate:
          //   "ok" -> Max-Age=AGE_TTL, a sliding 1-hour affirmation that the
          //           pre-paint probe in layout/theme.liquid renews on every
          //           page load while the visitor is on the site.
          //   "no" -> NO Max-Age, i.e. a SESSION cookie, exactly as before.
          // Never put an expiry on the refusal. An expiring decline is a
          // decline that lets someone back in, and this control may only ever
          // err toward SHOWING the gate.
          const maxAge = value === "ok" ? ";Max-Age=" + $this.AGE_TTL : "";
          document.cookie =
            $this.AGE_COOKIE +
            "=" +
            encodeURIComponent(value) +
            ";path=/" +
            maxAge +
            ";SameSite=Lax" +
            (window.location.protocol === "https:" ? ";Secure" : "");
          // Read back rather than trust the assignment: a blocked jar accepts
          // the write silently and stores nothing.
          return $this.ageState() === value;
        } catch (error) {
          return false;
        }
      },

      /*
       * Age popup - the visitor affirmed they are 18 or over
       */
      agePopup: function () {
        const stored = $this.setAgeState("ok");
        // The gate is display:flex by DEFAULT (fail-closed CSS), and only this
        // class takes it down. It must be set even when the cookie write
        // failed, or the visitor affirms and the gate never leaves the screen.
        // A failed write simply means the gate returns on the next navigation -
        // the safe direction.
        document.documentElement.classList.add("tps-age-ok");

        // Lift the inline background lockout applied at the end of body parse by
        // layout/theme.liquid. That block inerts every top-level container while
        // the gate is up, so a keyboard user cannot tab behind the gate even when
        // THIS file fails to load. Releasing it is the affirmed visitor's only
        // route back to an interactive store, so it runs here - inside the
        // audited writer of the affirm state - and not on any cosmetic path that
        // may throw. Only attributes that block set are lifted: the data- tag is
        // the ledger, so an inert set by anything else is left alone.
        try {
          document
            .querySelectorAll("[data-tps-age-inert]")
            .forEach(function (el) {
              el.removeAttribute("inert");
              el.removeAttribute("aria-hidden");
              el.removeAttribute("data-tps-age-inert");
            });
        } catch (error) {
          /* An affirmed visitor must never be left staring at a dead page. */
        }

        // Lift the MODAL LOCKOUT the gate installed when it opened. openPopup()
        // put popup-scroll-hidden (+ -mobile) on <body>, and modalGuard.engage()
        // caged the background behind inert/aria-hidden. html.tps-age-ok only
        // takes the gate OFF THE SCREEN - it undoes neither of those. The gate
        // vanished on affirm and left the visitor on a store that looked open,
        // could not be scrolled (body overflow:hidden propagates to the
        // viewport, and touch-action:none kills the gesture outright on a
        // phone) and could not be tabbed into. A fresh navigation re-rendered
        // <body> without the class, which is exactly why leaving the page and
        // coming back "fixed" it and why the fault was invisible to anyone
        // already past the gate on the 24h cookie.
        // This runs HERE, beside the inline lockout above and for the same
        // stated reason: agePopup() is the one audited admit path, so the
        // release cannot be missed by a future caller. decline() deliberately
        // does NOT come through here - a declined visitor must stay locked.
        try {
          document.body.classList.remove("popup-scroll-hidden");
          document.body.classList.remove("popup-scroll-hidden-mobile");
          // No argument: release whatever this guard actually engaged. It also
          // restores focus to #MainContent with preventScroll, which is the
          // behaviour the guard already documents directly above.
          $this.modalGuard.release();
        } catch (error) {
          /* An affirmed visitor must never be left staring at a dead page. */
        }
        return stored;
      },

      /*
       * Age declined - the visitor answered "I am under 18"
       */
      ageDeclined: function () {
        // FIRST, remember it. The old build persisted NOTHING here: a visitor
        // who declared themselves under 18 was handed the entire catalogue by
        // pressing reload. Written before any DOM work so that a throw further
        // down cannot lose the answer. Never in the theme editor - that would
        // lock the merchant out of their own section.
        if (!(window.Shopify && Shopify.designMode)) {
          $this.setAgeState("no");
        }
        // Note: no "tps-age-ok" class here, by design. The gate stays painted.

        document
          .querySelectorAll(".age-verification__question")
          .forEach(function (el) {
            el.classList.remove("show");
          });
        const declined = document.querySelector(".age-verification__declined");
        declined?.classList.add("show");

        // The dialog's NAME and its DESCRIPTION both pointed into the ENTRY
        // panel, which has just gone display:none. Re-point BOTH at the
        // declined panel so a screen reader that re-announces the dialog
        // describes the state the visitor is actually in.
        //
        // aria-labelledby was already swapped here. aria-describedby was NOT,
        // and that was TIR-10 (WCAG 4.1.2): the wrapper kept pointing at
        // tpsg-body-[section.id] inside .age-verification__question, so Chrome
        // computed the declined dialog's description as "This website sells
        // tobacco products. You must be 18 or older to enter." - a sentence
        // that is not on screen - while the sentence that IS on screen
        // ("...Australian law requires us to limit this website to people aged
        // 18 and over.") was never conveyed at all. Swap them together, always.
        //
        // Selected by data attribute, never by tag or class - the headings in
        // this gate have already been demoted h1 -> h2 once. Fully
        // null-guarded, independently per attribute: a theme missing either
        // element simply keeps that attribute's old target rather than
        // pointing at nothing, because an aria-* IDREF that resolves to no
        // element is worse than a stale one.
        //
        // NOTHING SWAPS THESE BACK, and nothing needs to: the only route out
        // of the declined state is ageRecover(), which reloads the page, so
        // the server re-serves the entry pairing from the section markup.
        if (declined) {
          const gate = declined.closest(".age-verification");
          const decHeading = declined.querySelector(
            "[data-tpsg-declined-heading]"
          );
          const decBody = declined.querySelector("[data-tpsg-declined-body]");
          if (gate && decHeading && decHeading.id) {
            gate.setAttribute("aria-labelledby", decHeading.id);
          }
          if (gate && decBody && decBody.id) {
            gate.setAttribute("aria-describedby", decBody.id);
          }
        }

        // Drop the inert ledger BEFORE the strip. modalGuard.inerted holds hard
        // references to the very .shopify-section elements the next block
        // removes, so a retained ledger keeps every detached node - and its
        // whole subtree, images included - alive for the rest of the page view.
        // Nothing is lost by forgetting it: the surviving siblings keep their
        // inert + aria-hidden attributes, which is exactly what a permanently
        // trapped gate needs, and the gate never closes from the declined
        // state. The recovery control reloads the page rather than releasing.
        $this.modalGuard.inerted = [];
        // Stop the background observer too. The section strip below is a burst
        // of childList mutations, and re-running the lockout pass against a
        // page being dismantled would only refill the ledger we just dropped.
        $this.modalGuard.unwatchBackground();

        // Remove all sections except age verification.
        // GUARDED: this used to read window.Shopify.designMode unguarded while
        // the sibling check above correctly guarded `window.Shopify &&`. Where
        // window.Shopify is undefined - a storefront rendered without the
        // Shopify global, or an early call before it is assigned - this threw
        // AFTER the cookie had already been written, so the visitor was
        // recorded as declined while the catalogue stayed on screen behind a
        // half-built panel.
        if (!(window.Shopify && Shopify.designMode)) {
          document.querySelectorAll(".shopify-section").forEach((el) => {
            if (!el.classList.contains("age-verification-section")) {
              el.remove();
            }
          });
        }

        // The declining button just went hidden with its panel, which drops focus
        // to <body>. Move it into the declined message so the trap still has an
        // anchor and a screen reader hears the outcome. The gate stays up and
        // stays trapped - declining must not hand the catalogue back.
        if (declined) {
          declined.setAttribute("tabindex", "-1");
          declined.focus();
        } else if ($this.modalGuard.popup) {
          $this.modalGuard.focusInto();
        }
      },

      /*
       * 18+ gate recovery - "Enter my date of birth again"
       * ----------------------------------------------------------
       * THE BIGGEST REVENUE RISK IN THE DOB CHANGE. With a yes/no gate, being
       * declined was a decision. With a date of birth it is most often a TYPO -
       * a transposed year, a month in the day box - and without a way back that
       * customer is locked out for the whole browser session.
       *
       * EXPIRE THEN RELOAD, IN THAT ORDER. Re-showing the entry panel in place
       * cannot work and must not be attempted: by the time this control is on
       * screen, ageDeclined() has already stripped every other section from the
       * DOM, so "back to entry" would hand the visitor a form on a gutted page.
       * Worse, openTriggerPopup() re-fires ageDeclined() on EVERY subsequent
       * load while the cookie still reads "no", so a reload without clearing
       * the cookie first simply declines them again.
       *
       * Belt and braces on the clear: an empty value is written as well as
       * Max-Age=0, because a jar that refuses deletion may still accept an
       * overwrite - and ageState() reads an empty value as UNKNOWN, which shows
       * the entry panel. Both directions fail safe: a clear that does not stick
       * leaves the visitor declined, never admitted.
       */
      ageRecover: function () {
        try {
          const secure =
            window.location.protocol === "https:" ? ";Secure" : "";
          document.cookie =
            $this.AGE_COOKIE + "=;path=/;SameSite=Lax" + secure;
          document.cookie =
            $this.AGE_COOKIE + "=;path=/;Max-Age=0;SameSite=Lax" + secure;
          document.cookie =
            $this.AGE_COOKIE +
            "=;path=/;expires=Thu, 01 Jan 1970 00:00:00 GMT;SameSite=Lax" +
            secure;
        } catch (error) {
          /* A blocked jar cannot hold "no" either, so the reload lands on the
             entry panel regardless. Never block the reload on the write. */
        }
        window.location.reload();
      },

      /* ====================================================================
       * ageDob — THE 18+ DATE-OF-BIRTH CONTROLLER ("The Register line": three
       * typed digit wells)   Hephaestus, 2026-10-03, founder pick 20:45.
       * ====================================================================
       * Drives sections/age-verification.liquid. It supersedes the native
       * <select> controller of the same name (2026-09-10 design); the founder
       * picked design B on 2026-10-03 and Themis ruled it CLEAR-WITH-CONDITIONS
       * (tps-v6-port/design/gate/GATE-themis-gate-options-2026-10-03.md, C-1..
       * C-9), Daedalus countersigned BUILD-WITH-CHANGES. Nothing in the theme
       * references data-tpsd-sel any more.
       *
       * THE OBJECT KEY AND init() SIGNATURE ARE A CONTRACT. popup.js's own
       * init() calls $this.ageDob.init(e) BEFORE popupInit(), because popupInit
       * is what opens the gate and, for a visitor whose cookie already reads
       * "no", immediately calls ageDeclined(). Do not rename either.
       *
       * ── FIVE THINGS THIS FILE MUST KEEP TRUE ─────────────────────────────
       *
       * 1. THE DATE NEVER LEAVES THE BROWSER. There is no fetch, no XHR, no
       *    sendBeacon, no dataLayer push, no Shopify.analytics call, no
       *    localStorage and no sessionStorage anywhere below. The eight digits
       *    live in three <input> elements and in local variables inside
       *    mount(), and both are wiped before any verdict is acted on. The
       *    verdict functions write ONE BOOLEAN: agePopup() and ageDeclined()
       *    store "ok" or "no" in tps_age18 and nothing else — never a date,
       *    never an age, never a year. If you ever need to know how often the
       *    gate declines, the answer is not to instrument this file.
       *
       * 2. THE MIRROR IS CLOSED BY rr-block, NOT BY THIS FILE. Typed digits are
       *    visible DOM text, so `rr-block` on the gate wrapper is mandatory
       *    (measured 2026-09-10: rr-ignore and rr-mask both leaked). What THIS
       *    file must not do is add a SECOND mirror: the live region below never
       *    repeats a typed value. It says "Please check your date of birth.",
       *    never a date.
       *
       * 3. THE CUTOFF COMES FROM THE SERVER, AND ONLY FROM THE SERVER (Themis
       *    C-4, fail closed). data-tpsd-today is rendered by Liquid from the
       *    shop clock. If it is absent or unparseable this controller REFUSES
       *    TO ARM: it returns before wiring anything, "Enter site" keeps the
       *    `disabled` it ships with in the HTML, and nobody is admitted. There
       *    is deliberately NO device-clock fallback — a minor winding their
       *    clock forward must not be able to move the threshold, and neither
       *    must a Liquid bug. Nothing below ever displays a computed age, the
       *    cutoff, or a verdict number.
       *
       * 4. THE UNDER-18 SPLIT (Themis Q4, confirmed 2026-10-03).
       *      impossible date (31/02, month > 12, day < 1, year < today − 110)
       *      or a future date   → NOT a date of birth, so no verdict exists:
       *                           wells KEPT (R3A-21), live region "Please check your
       *                           date of birth.", focus to Day, NO cookie.
       *      real date under 18 → ageDeclined(): session "no" cookie (never
       *                           an expiry), declined panel, dialog
       *                           re-pointed, focus to the refusal heading.
       *      "Leave site"       → the same ageDeclined() path. Declines in
       *                           place, never navigates, never to TPW.
       *      18 or over         → the 240ms exit, then agePopup().
       *    The declined panel is byte-identical whatever the margin, so nothing
       *    on it tells a visitor which answer failed or that another would pass.
       *
       * 5. ENTER ENABLES ON COMPLETENESS ONLY — eight digits present — and
       *    never on the date, so the button state can never be read backwards
       *    to learn the verdict. The verdict happens on press (click, or the
       *    Enter KEY in a well). It never auto-submits (WCAG 3.2.2).
       * ==================================================================== */
      ageDob: {
        // Days per month, January first. February is resolved by daysIn()
        // against the typed year.
        DAYS: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],

        init: function () {
          document.querySelectorAll("[data-tpsd-root]").forEach(function (root) {
            if (root.getAttribute("data-tpsd-bound")) return;
            root.setAttribute("data-tpsd-bound", "true");
            try {
              $this.ageDob.mount(root);
            } catch (error) {
              // A throw here must not take the rest of popup.js down with it,
              // and it must not admit anyone. "Enter site" ships `disabled` in
              // the HTML and nothing above has enabled it yet, so the gate
              // simply stays up. Fail closed on our own bug too.
              root.setAttribute("data-tpsd-bound", "error");
            }
          });
        },

        // A real leap year, not the four-year approximation. 1900 was not a
        // leap year and is inside this control's range.
        isLeap: function (y) {
          return (y % 4 === 0 && y % 100 !== 0) || y % 400 === 0;
        },

        daysIn: function (month, year) {
          var api = $this.ageDob;
          if (month < 1 || month > 12) return 0;
          if (month !== 2) return api.DAYS[month - 1];
          return api.isLeap(year) ? 29 : 28;
        },

        mount: function (root) {
          var api = $this.ageDob;

          var dEl = root.querySelector('[data-tpsd-well="d"]');
          var mEl = root.querySelector('[data-tpsd-well="m"]');
          var yEl = root.querySelector('[data-tpsd-well="y"]');
          var goEl = root.querySelector("[data-tpsd-submit]");
          var leaveEl = root.querySelector("[data-tpsg-leave]");
          var liveP = root.querySelector(".tpsb__live");
          var liveEl = root.querySelector("[data-tpsd-live]");
          var decHead = root.querySelector("[data-tpsg-declined-heading]");
          var gate = root.closest(".age-verification");

          // Any missing part means the markup and this controller have drifted.
          // Return without wiring anything: "Enter site" keeps its `disabled`
          // and the gate stays up. Fail closed on drift.
          if (!dEl || !mEl || !yEl || !goEl) return;

          var wells = [dEl, mEl, yEl];

          /* ---- 1. THE THRESHOLD, FROM THE SERVER ------------------------ */
          var parsed = /^(\d{4})-(\d{2})-(\d{2})$/.exec(
            root.getAttribute("data-tpsd-today") || ""
          );
          if (!parsed) return; // see contract 3 above. No fallback. No arming.

          var todayY = parseInt(parsed[1], 10);
          var todayM = parseInt(parsed[2], 10);
          var todayD = parseInt(parsed[3], 10);
          if (
            !todayY ||
            todayM < 1 || todayM > 12 ||
            todayD < 1 || todayD > 31
          ) {
            return;
          }

          // Born on or before this date => 18 or over TODAY. Someone whose
          // eighteenth birthday is today lands exactly ON the cutoff and is
          // admitted; someone whose eighteenth birthday is tomorrow is one day
          // past it and is declined.
          //
          // Compared as a (y, m, d) tuple rather than through Date, so no
          // timezone, no DST and no month-overflow normalisation can move it.
          // The 29 February case needs no special handling: a visitor born on
          // 29 Feb Y turns 18 on 1 Mar Y+18 in a non-leap year — on 28 Feb
          // Y+18 the tuple (Y, 2, 29) is AFTER the cutoff (Y, 2, 28), so they
          // are declined; on 1 Mar Y+18 the cutoff is (Y, 3, 1) and (Y, 2, 29)
          // is before it, so they are admitted. Exactly the legal roll-over.
          var cutY = todayY - 18;
          var cutM = todayM;
          var cutD = todayD;
          var floorY = todayY - 110; // plausibility bound, not an age rule

          var reduce = false;
          try {
            reduce = !!(
              window.matchMedia &&
              window.matchMedia("(prefers-reduced-motion: reduce)").matches
            );
          } catch (error) {
            reduce = false;
          }

          root.setAttribute("data-tpsd-armed", "true");

          /* ---- 2. STATE, ALL OF IT LOCAL -------------------------------- */
          var done = false;
          var kbPreferGo = false; // R2H-02 (6b): Enter is fitted first once every digit is in

          // The live region says ONE thing, and never a typed value.
          function say(message) {
            if (liveEl) liveEl.textContent = message || " ";
            if (liveP) liveP.classList.toggle("is-on", !!message);
          }

          // Completeness ONLY. This function must never consult the date
          // against the cutoff: if the button's state could be read backwards,
          // the verdict would leak before the visitor pressed anything.
          //
          // ★ aria-disabled, NOT the disabled PROPERTY. The button SHIPS with a
          // real `disabled` attribute in the HTML — the fail-closed floor a
          // no-JS visitor meets. But a truly disabled button is removed from
          // the tab order outright, and a screen-reader user in focus mode then
          // never meets the primary control at all. So the moment the
          // controller ARMS (the swap in the boot block below) the real
          // attribute is dropped and this attribute takes over. .is-ready is
          // the ink fill; it tracks the same completeness bit and nothing else.
          function complete() {
            return wells.every(function (w) {
              return w.value.length === w.maxLength;
            });
          }
          function arm() {
            var ok = complete();
            // R2H-02: the moment the 8th digit lands, "Enter site" becomes what the visitor needs
            // in view. 6b fits Enter first from here until a well is focused again.
            var wasOk = goEl.getAttribute("aria-disabled") === "false";
            goEl.setAttribute("aria-disabled", ok ? "false" : "true");
            goEl.classList.toggle("is-ready", ok);
            kbPreferGo = ok && (!wasOk || kbPreferGo);
            if (ok && !wasOk && typeof kbQueue === "function") kbQueue();
          }

          // Clear the date out of the elements and the message, without
          // announcing anything. Called before every verdict is acted on, so by
          // the time agePopup() or ageDeclined() runs there is nothing left on
          // screen or in scope.
          function wipe() {
            try {
              wells.forEach(function (w) {
                w.value = "";
                w.parentNode.classList.remove("has-val");
              });
              say("");
              arm();
            } catch (error) {
              /* The verdict must never be blocked by a cosmetic failure. */
            }
          }

          function focusWell(w) {
            try {
              w.focus({ preventScroll: true });
            } catch (error) {
              /* Cosmetic only. */
            }
          }

          /* ---- 3. PARSE: null = not a date of birth, "ok" / "no" = verdict */
          function parse() {
            var d = parseInt(dEl.value, 10);
            var m = parseInt(mEl.value, 10);
            var y = parseInt(yEl.value, 10);
            if (isNaN(d) || isNaN(m) || isNaN(y)) return null;
            if (y < floorY || m < 1 || m > 12 || d < 1) return null;
            if (d > api.daysIn(m, y)) return null;
            // A future date is not a date of birth.
            var future =
              y > todayY ||
              (y === todayY && (m > todayM || (m === todayM && d > todayD)));
            if (future) return null;
            var pass =
              y < cutY ||
              (y === cutY && (m < cutM || (m === cutM && d <= cutD)));
            return pass ? "ok" : "no";
          }

          /* ---- 4. OUTCOMES --------------------------------------------- */
          function admit() {
            done = true;
            document.removeEventListener("keydown", onKey, true);
            wipe();
            // agePopup() writes tps_age18=ok, adds html.tps-age-ok, lifts the
            // inline background lockout and releases modalGuard (focus to
            // main#MainContent). It is the ONLY writer of the affirm state and
            // it stores a boolean, never the answer.
            //
            // THE EXIT (Themis C-1, Daedalus exit cure). The gate slides up
            // 240ms (transform only, .is-leaving in base.css) and agePopup()
            // runs when the transform ends. The band outranks the gate in
            // z-order, so the gate passes UNDER the band, never over it. Under
            // prefers-reduced-motion the exit is instant: no class, no wait.
            // A fallback timer covers a browser that never fires transitionend
            // (transition disabled, tab in the background) so an affirmed
            // visitor is never left waiting on an event that cannot arrive.
            if (reduce || !gate) {
              $this.agePopup();
              return;
            }
            var finished = false;
            var finish = function () {
              if (finished) return;
              finished = true;
              try {
                gate.removeEventListener("transitionend", onEnd);
              } catch (error) {
                /* already gone */
              }
              $this.agePopup();
              gate.classList.remove("is-leaving");
            };
            var onEnd = function (e) {
              if (e && e.target !== gate) return;
              finish();
            };
            gate.addEventListener("transitionend", onEnd);
            gate.classList.add("is-leaving");
            window.setTimeout(finish, 320);
          }

          function decline() {
            done = true;
            document.removeEventListener("keydown", onKey, true);
            // Wipe FIRST. ageDeclined() writes the session "no", swaps the
            // panels, strips every other section from the DOM and re-points
            // the dialog's aria wiring; the date must already be gone before
            // any of that runs. Nothing animates on this path.
            wipe();
            $this.ageDeclined();
            // ageDeclined() leaves focus on the declined panel (its cookie-"no"
            // reload path). On a live decline move it to the refusal HEADING
            // (tabindex="-1" in the markup) so a screen reader hears the
            // outcome and the trap keeps an anchor (Tiresias BLOCK-03).
            if (decHead) {
              try {
                if (!decHead.hasAttribute("tabindex")) {
                  decHead.setAttribute("tabindex", "-1");
                }
                decHead.focus({ preventScroll: true });
              } catch (error) {
                /* Focus is a courtesy; the refusal stands without it. */
              }
            }
          }

          // THE MUTE RETRY (Themis Q4, GREEN). Not a verdict: the typed value
          // was not a date of birth. One neutral sentence, no age, no field, no
          // cookie, focus back to Day.
          // R3A-21 (Orion 2026-10-04): the typed digits STAY. This used to wipe()
          // all three wells, so "31/02/2000" vanished behind the one sentence
          // and the visitor retyped the whole line to fix one well. Nothing
          // about the verdict changes: it is still not a verdict, still no
          // cookie, still one neutral sentence, and the wells are still wiped
          // before agePopup()/ageDeclined() run. The button keeps its ready
          // state (eight digits are still present) so the corrected line can
          // be pressed again.
          function retry() {
            say("Please check your date of birth.");
            focusWell(dEl);
          }

          function submit() {
            if (done) return;

            // Not complete yet. A press on the outline pill puts the visitor
            // in the first empty well and says nothing: the live region is
            // reserved for the mute retry.
            if (goEl.getAttribute("aria-disabled") === "true") {
              var first = wells.filter(function (w) {
                return w.value.length < w.maxLength;
              })[0];
              if (first) focusWell(first);
              return;
            }

            var verdict = parse();
            if (verdict === null) {
              retry();
              return;
            }
            if (verdict === "no") {
              decline();
              return;
            }
            admit();
          }

          /* ---- 5. KEYBOARD --------------------------------------------- *
           * Tab containment is modalGuard's, not this file's. Its focusables()
           * selector counts input:not([disabled]) and button:not([disabled]),
           * so the three wells, Enter and Leave site are inside the trap with
           * no change to the trap.
           *
           * ESC IS HANDLED HERE AND NEVER DISMISSES THE GATE. popup.js's shared
           * ESC-to-close handler is fenced out by :not([data-tpsg-modal="true"]),
           * so a legal control cannot be keyed away. ESC is re-purposed to
           * CLEAR the wells, which is where a visitor's instinct to press it
           * leads somewhere useful instead of nowhere. */
          function onKey(e) {
            if (done) return;
            if (document.documentElement.classList.contains("tps-age-ok")) return;
            if (e.key !== "Escape") return;
            e.preventDefault();
            wipe();
            focusWell(dEl);
          }

          /* ---- 6. WIRING ------------------------------------------------ *
           * Digits only; auto-advance when a well is full (following the
           * visitor's own keystroke, never a verdict); Backspace on an empty
           * well steps back; arrows cross wells at the edges; the Enter KEY is
           * a press of the Enter BUTTON. Typing clears any retry message. */
          wells.forEach(function (w, i) {
            w.addEventListener("input", function () {
              var v = w.value.replace(/\D/g, "").slice(0, w.maxLength);
              if (v !== w.value) w.value = v;
              w.parentNode.classList.toggle("has-val", v.length > 0);
              say("");
              arm();
              if (v.length === w.maxLength && wells[i + 1]) focusWell(wells[i + 1]);
            });
            w.addEventListener("keydown", function (e) {
              if (done) return;
              if (e.key === "Backspace" && w.value === "" && wells[i - 1]) {
                e.preventDefault();
                focusWell(wells[i - 1]);
                return;
              }
              if (e.key === "Enter") {
                e.preventDefault();
                submit();
                return;
              }
              if (
                e.key === "ArrowRight" &&
                w.selectionStart === w.value.length &&
                wells[i + 1]
              ) {
                e.preventDefault();
                focusWell(wells[i + 1]);
                return;
              }
              if (e.key === "ArrowLeft" && w.selectionStart === 0 && wells[i - 1]) {
                e.preventDefault();
                focusWell(wells[i - 1]);
              }
            });
            w.addEventListener("focus", function () {
              try {
                w.select();
              } catch (error) {
                /* Cosmetic only. */
              }
            });
          });

          goEl.addEventListener("click", submit);

          // "Leave site": the same decline as a real under-18 date. Writes the
          // session "no" through ageDeclined(), shows the declined panel, never
          // navigates (Themis Q3; founder 2026-08-05).
          if (leaveEl) {
            leaveEl.addEventListener("click", function (e) {
              e.preventDefault();
              if (done) return;
              decline();
            });
          }

          document.addEventListener("keydown", onKey, true);

          /* ---- 6b. THE ON-SCREEN KEYBOARD (Hermes R1H-12, Themis K1) ------ *
           * A phone or tablet keyboard covers the bottom of the screen but does
           * not shrink the layout viewport, so the gate (position:fixed, full
           * height under the band) keeps its size and "Enter site" can sit
           * under the keys (iPad landscape: Enter at 567-623 in 820, keyboard
           * ~350-400). While a well or Enter has focus, this keeps the entry
           * line and the Enter row inside the VISUAL viewport by (1) reserving
           * the covered height as bottom padding on the gate's own scroller
           * (--tpsb-kb, read by the gate block in base.css), which also gives
           * that scroller room to move, and (2) scrolling THAT scroller, and
           * only that scroller, by the shortfall. It never scrolls the page,
           * never moves or restyles the band, never moves focus, changes no
           * string and adds no element. The focused control wins over Enter if
           * both cannot fit (typing blind is worse than one more scroll).
           * No visualViewport (old browsers): nothing runs, the gate is as before. */
          var vv = window.visualViewport;
          var scroller = gate ? gate.querySelector(".age-verification__wrapper") : null;
          var kbRaf = 0;
          var kbPreUntil = 0; // 6d: a predicted reserve is held until this time (ms)

          /* ---- 6c. THE BAND STAYS AT THE VISIBLE TOP (Hermes R2H-01, Themis C-1, reg 17(3)) ----
           * iOS pans the VISUAL viewport when a well takes focus and the keyboard
           * rises (visualViewport.offsetTop > 0). The band is position:fixed to
           * the LAYOUT viewport, so a pan of N px puts it N px above what the
           * visitor can see. While the gate is up and the page is at scale 1,
           * the band is moved down by exactly visualViewport.offsetTop, so its
           * top is the top of the visible area in every frame. It runs
           * SYNCHRONOUSLY inside the visualViewport event (never a later frame),
           * transform only, on the band's own box; size, artwork, z-order and
           * markup are untouched. offsetTop 0 (no keyboard, or keyboard closed)
           * removes the inline transform outright, so the seam with the gate is
           * the signed one again. Pinch-zoom (scale != 1) is the visitor
           * magnifying the page, not a keyboard: the band is left alone
           * (Tiresias R2T-05). After the affirm (html.tps-age-ok) it is never
           * touched. */
          function isZoomed() {
            return !!vv && Math.abs((vv.scale || 1) - 1) >= 0.01;
          }
          function fixedBands() {
            return Array.prototype.filter.call(
              document.querySelectorAll("[data-tps-warnband]"),
              function (b) {
                return window.getComputedStyle(b).position === "fixed";
              }
            );
          }
          function bandFollow() {
            if (!vv) return;
            var y = 0;
            if (
              gate &&
              !document.documentElement.classList.contains("tps-age-ok") &&
              !isZoomed()
            ) {
              y = vv.offsetTop || 0;
            }
            fixedBands().forEach(function (b) {
              if (Math.abs(y) < 0.5) {
                if (b.style.transform) b.style.removeProperty("transform");
              } else {
                b.style.transform = "translate3d(0," + y + "px,0)";
              }
            });
          }
          function kbReset() {
            if (gate) gate.style.removeProperty("--tpsb-kb");
          }
          function kbFit() {
            kbRaf = 0;
            if (!vv || !scroller || !gate) return;
            if (done || document.documentElement.classList.contains("tps-age-ok")) {
              kbReset();
              return;
            }
            // Tiresias R2T-05: pinch-zoom shrinks the visual viewport exactly as a
            // keyboard does. A magnified page is not a keyboard: no reserve, no scroll.
            if (isZoomed()) {
              kbReset();
              return;
            }
            var visTop = vv.offsetTop;
            var visBottom = vv.offsetTop + vv.height;
            var covered = Math.max(0, Math.round(window.innerHeight - visBottom));
            if (covered < 2) {
              // 6d: a reserve set at the touch, before focus, is kept while the keyboard is still
              // on its way; if none ever arrives (a hardware keyboard) it is dropped at the deadline.
              if (Date.now() < kbPreUntil) return;
              kbReset();
              return;
            }
            kbPreUntil = 0;
            gate.style.setProperty("--tpsb-kb", covered + "px");
            var active = document.activeElement;
            if (wells.indexOf(active) === -1 && active !== goEl) return;
            var lineRow = dEl.closest(".tpsb__row") || dEl;
            var goRow = goEl.closest(".tpsb__row") || goEl;
            var margin = 8;
            var g = goRow.getBoundingClientRect();
            var l = lineRow.getBoundingClientRect();
            var a = active.getBoundingClientRect();
            var gateTop = Math.max(visTop, gate.getBoundingClientRect().top);
            // 6c: while the band follows a pan it covers the top of the visible area, so the
            // first uncovered line of the gate is the band's bottom edge, not the visible top.
            fixedBands().forEach(function (b) {
              gateTop = Math.max(gateTop, b.getBoundingClientRect().bottom);
            });
            var dy = 0;
            var goFits = false;
            if (kbPreferGo) {
              // R2H-02: all 8 digits are in. Enter wins: its whole row above the keys and below the band.
              if (g.bottom > visBottom - margin) dy = g.bottom - (visBottom - margin);
              if (g.top - dy < gateTop + margin) dy = g.top - (gateTop + margin);
              // ...but never by sliding the focused well under the band (C-1: the band never covers
              // what has focus). Where both cannot fit (iPhone landscape, 96px between band and keys)
              // the focused well keeps its place and Enter stays one Next or one swipe away.
              if (a.top - dy < gateTop + margin) dy = Math.min(dy, a.top - (gateTop + margin));
              // a move that still leaves Enter under the keys buys nothing: keep the R1 fit instead
              goFits = g.bottom - dy <= visBottom - margin + 0.5;
              if (!goFits) dy = 0;
            }
            if (!goFits) {
            if (g.bottom > visBottom - margin) dy = g.bottom - (visBottom - margin);
            // never lift the line (and so the focused well) above the top of what can be seen
            if (l.top - dy < gateTop + margin) dy = Math.max(0, l.top - (gateTop + margin));
            // 6c: a line already under the band is brought back down below it
            if (dy === 0 && l.top < gateTop + margin) dy = l.top - (gateTop + margin);
            if (a.bottom - dy > visBottom - margin) dy = a.bottom - (visBottom - margin);
            }
            if (dy > 0.5) scroller.scrollTop += Math.ceil(dy);
            else if (dy < -0.5) scroller.scrollTop += Math.floor(dy);
          }
          function kbQueue() {
            if (!kbRaf) kbRaf = window.requestAnimationFrame(kbFit);
          }
          if (vv && gate) {
            // 6c runs inside the event itself, so the band moves in the frame the pan is painted.
            vv.addEventListener("resize", bandFollow);
            vv.addEventListener("scroll", bandFollow);
          }
          /* ---- 6d. RESERVE AT THE TOUCH, BEFORE FOCUS (Hermes R2H-01) ----------
           * iOS chooses its focus pan at the instant a well takes focus, before any
           * visualViewport event reaches 6b, and at that instant the well sits
           * below the line the keyboard will rise to. So on the touch itself
           * (recorded at pointerdown, applied in focus: see WHEN below), on a coarse pointer, with no
           * keyboard up and the page at scale 1, the predicted keyboard height is
           * reserved as --tpsb-kb and the gate's OWN scroller lifts the entry line
           * above that line (never above the band). When focus lands there is
           * nothing for Safari to pan. 6b takes over with the real height when the
           * keyboard reports; 6c (band follows the pan) stays as the safety net.
           * Prediction: 0.42 of the height upright, 0.52 on its side (measured
           * keyboards: iPhone 336/844, iPad 320/1180, iPad 380/820, iPhone 200/390).
           * Nothing here moves focus, the page, the band or any string.
           * WHEN, exactly: the touch is only RECORDED on pointerdown; the reserve
           * and the scroll run synchronously inside the well's own focus event,
           * which a tap dispatches before the browser starts its reveal. Moving
           * the column AT pointerdown re-centres it under the finger, and the tap
           * then lands on whatever slid there (measured in Chromium: focus went to
           * the gate's wrapper, not the well). In focus, the well already owns
           * focus, so nothing can be mis-targeted. A hardware-keyboard Tab into a
           * well (no touch) never reserves. */
          var kbTouchAt = 0;
          function kbTouch(e) {
            if (e && e.pointerType === "mouse") return;
            kbTouchAt = Date.now();
          }
          function kbPre() {
            if (!vv || !scroller || !gate || done) return;
            if (Date.now() - kbTouchAt > 1000) return;
            kbTouchAt = 0;
            if (document.documentElement.classList.contains("tps-age-ok")) return;
            if (!(window.matchMedia && window.matchMedia("(pointer: coarse)").matches)) return;
            if (isZoomed()) return;
            var ih = window.innerHeight;
            if (ih - (vv.offsetTop + vv.height) >= 2) return; // a keyboard is already up: 6b fits
            var kb = Math.round(ih * (window.innerWidth > ih ? 0.52 : 0.42));
            kbPreUntil = Date.now() + 1500;
            gate.style.setProperty("--tpsb-kb", kb + "px");
            var lineRow = dEl.closest(".tpsb__row") || dEl;
            var l = lineRow.getBoundingClientRect();
            var top = gate.getBoundingClientRect().top;
            fixedBands().forEach(function (b) {
              top = Math.max(top, b.getBoundingClientRect().bottom);
            });
            var margin = 8;
            var dy = 0;
            if (l.bottom > ih - kb - margin) dy = l.bottom - (ih - kb - margin);
            if (l.top - dy < top + margin) dy = Math.max(0, l.top - (top + margin));
            if (dy > 0.5) scroller.scrollTop += Math.ceil(dy);
            window.setTimeout(kbQueue, 1550);
          }
          if (vv && scroller) {
            wells.forEach(function (el) {
              el.addEventListener("pointerdown", kbTouch, { passive: true });
              el.addEventListener("focus", function () {
                // a well taken again re-takes priority from Enter (R2H-02)
                kbPreferGo = false;
                kbPre();
              });
            });
          }
          if (vv && scroller) {
            vv.addEventListener("resize", kbQueue);
            vv.addEventListener("scroll", kbQueue);
            wells.concat([goEl]).forEach(function (el) {
              el.addEventListener("focus", function () {
                kbQueue();
                // the keyboard animates in after focus; measure again once it has landed
                window.setTimeout(kbQueue, 350);
              });
            });
          }

          /* ---- 7. BOOT --------------------------------------------------
           * Start from a known-empty state. A back/forward navigation can
           * restore an <input> to its previous value from the bfcache, and a
           * restored date of birth is both a stale answer and a value the
           * visitor did not give on this visit.
           *
           * ★ THE ARM SWAP. This is the ONLY place the real `disabled`
           * attribute is dropped, and it is reached only after the server date
           * has parsed and every element has been found. Everything above this
           * line returns early on failure, and every early return leaves the
           * attribute exactly as Liquid shipped it. Do not hoist this. */
          goEl.disabled = false;
          goEl.setAttribute("aria-disabled", "true");
          wipe();
        },
      },

      /*
       * Accept popup
       */
      acceptPopup: function (event) {
        let el = event.target ? event.target : event;

        // Get popup container.
        let popup = el.closest(".popup");
        $this.setStorage("popup-accept-" + popup.getAttribute("data-id"), 1, {
          expires: 360,
        });
      },

      /*
       * Close popup
       */
      closePopup: function (event) {
        let el = event.target ? event.target : event;
        // Get popup container.
        let popup = el.closest(".popup");
        // Release the focus trap + background inert before the exit animation,
        // so the page behind is operable the moment the popup starts leaving.
        $this.modalGuard.release(popup);
        // Close animation.
        let animation = popup.getAttribute("data-exit-animation");
        $this.applyAnimation(popup, animation, function () {
          // Already opened.
          popup.classList.add("popup-already-opened");
          // Hide popup.
          popup.classList.remove("popup-open");

          popup.blur();
        });
        document.body.classList.remove("popup-scroll-hidden");
        document.body.classList.remove("popup-scroll-hidden-mobile");
      },

      /*
       * Checks whether a popup should be displayed or not
       */
      isAllowPopup: function (popup) {
        // Has user seen this popup before?
        let limitDisplay = parseInt(
          popup.getAttribute("data-limit-display") || 0
        );
        let limitDisplayStored = parseInt(
          $this.getStorage("popup-" + popup.getAttribute("data-id"))
        );
        // GUARDED, same defect class as the one fixed in ageDeclined(): an
        // unguarded window.Shopify dereference throws where the global is
        // absent. This one threw inside popupInit's forEach and killed every
        // popup after it. The gate no longer reaches this function at all, but
        // a throw here would still abort the loop before later popups mount.
        if (
          !(window.Shopify && Shopify.designMode) &&
          limitDisplay &&
          limitDisplayStored &&
          limitDisplayStored >= limitDisplay
        ) {
          return false;
        }
        return true;
      },

      /*
       * Apply animation
       */
      applyAnimation: function (el, name, callback) {
        var popup = el.closest(".popup");
        let overlayName;
        if (typeof callback === "function") {
          overlayName = "popupExitFade";
        } else {
          overlayName = "popupOpenFade";
        }
        // Overlay Animation.
        if (popup.nextElementSibling) {
          popup.nextElementSibling.classList.add("popup-animated", overlayName);
          popup.nextElementSibling.addEventListener(
            "animationend",
            function () {
              this.classList.remove("popup-animated", overlayName);
            },
            { once: true }
          );
        }
        // Wrap Animation.
        //
        // `name` comes straight from a data-*-animation attribute and is null on
        // any popup that sets none - the 18+ gate among them. It used to be
        // passed to classList.add() unchecked, which added a class literally
        // called "null", matched no keyframes, and so never fired animationend:
        // the callback never ran and popup-open / popup-animated were never
        // cleaned off. Cosmetic on the gate (tps-age-ok has already taken it
        // down by then) but it left the close path depending on an event that
        // could not arrive.
        var wrap = popup.querySelector(".popup-wrap");
        if (!wrap) {
          if (typeof callback === "function") callback();
          return;
        }
        if (!name) {
          if (typeof callback === "function") callback();
          return;
        }
        wrap.classList.add("popup-animated", name);
        wrap.addEventListener(
          "animationend",
          function () {
            // remove the animation classes after animation ends
            // required in order to apply new animation on close
            this.classList.remove("popup-animated", name);
            if (typeof callback === "function") {
              callback();
            }
          },
          { once: true }
        );
      },

      /*
       * Get local storage
       */
      getStorage: function (key) {
        // MEASURED: localStorage.getItem() used to sit OUTSIDE this
        // try/catch. Where storage throws - Safari private browsing, "block all
        // cookies", an enterprise policy - the exception escaped isAllowPopup(),
        // escaped the .popup forEach in popupInit(), and aborted popupInit
        // ENTIRELY, so the 18+ gate never mounted. Proven fail-OPEN.
        // Every read now degrades to undefined, and every caller reads undefined
        // as "not seen yet", so the popup shows.
        try {
          const item = localStorage.getItem(key);
          if (!item) return undefined;

          const parsed = JSON.parse(item);
          if (parsed.expires && Date.now() > parsed.expires) {
            localStorage.removeItem(key);
            return undefined;
          }
          return parsed.value;
        } catch {
          return undefined;
        }
      },

      /*
       * Set local storage
       */
      setStorage: function (key, value, options = {}) {
        const data = {
          value,
          expires: null,
        };
        if (options.expires) {
          const expiresDate = new Date();
          expiresDate.setDate(
            expiresDate.getDate() + parseInt(options.expires, 10)
          );
          data.expires = expiresDate.getTime();
        }
        // openPopup() writes its display counter BEFORE it adds .popup-open, so
        // a throw here used to suppress the popup entirely - the same fail-OPEN
        // as getStorage. Writes are best-effort now: a lost write only means the
        // popup is shown again, which is the safe direction.
        try {
          localStorage.setItem(key, JSON.stringify(data));
          return true;
        } catch {
          return false;
        }
      },

      /*
       * Get scroll percent
       */
      getScrollPercent: function () {
        const h = document.documentElement,
          b = document.body,
          st = "scrollTop",
          sh = "scrollHeight";
        return ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100;
      },
    };
  })();

  // Initialize.
  adpPopup.init();

  document.addEventListener("shopify:section:load", function () {
    adpPopup.init();
  });

  document.addEventListener("shopify:section:unload", function () {
    document.body.classList.remove("popup-scroll-hidden");
  });
});
